<template>
    <div>
        <tabs-component></tabs-component>
        <div class="mx-2 my-2">
            <b-alert show dismissible variant="success" v-if="verify_mail_success">Successful activation. Your email was validated correctly.</b-alert>
            <div class="alert alert-success" v-if="email_changed">
                <p>An email was sent to {{ form.email }}. Please check your inbox or spam folder.</p>
            </div>
            <b-alert show dismissible variant="error" v-if="error">{{ error_message }}</b-alert>
        </div>
        <section class="content">
            <div class="row">
                <div class="col-md-6">
                    <b-form @submit.prevent="onSubmit" class="form-group">
                        <b-form-group id="form_acccount_name"
                                      label="Enter your Name:"
                                      label-for="form_acccount_name"
                                      description="Your full name">
                            <b-form-input id="form_account_name"
                                          type="text"
                                          v-model="form.name"
                                          v-validate="'required'"
                                          :state="errors.has('name') ? false: null"
                                          name="name"
                                          required>
                            </b-form-input>
                            <em v-if="errors.has('name')" class="text-danger">
                                {{ errors.first('name') }}
                            </em>
                        </b-form-group>
                        <b-form-group id="form_acccount_email"
                                      label="Email:"
                                      description="Your email"
                                      label-for="form_acccount_email">
                            <b-form-input id="form_account_email"
                                          type="email"
                                          v-model="form.email"
                                          v-validate="'required|email'"
                                          :state="errors.has('email') ? false: null"
                                          name="email"
                                          required>
                            </b-form-input>
                            <em v-if="errors.has('email')" class="text-danger">
                                {{ errors.first('email') }}
                            </em>
                        </b-form-group>
                        <b-form-group id="form_acccount_password"
                                      label="Password:"
                                      description="For security reasons enter your password"
                                    label-for="form_account_password">
                            <b-form-input id="form_account_password"
                                          type="password"
                                          v-model="form.password"
                                          v-validate="'required'"
                                          :state="errors.has('password') ? false: null"
                                          name="password">
                            </b-form-input>
                            <em v-if="errors.has('password')" class="text-danger">
                                {{ errors.first('password') }}
                            </em>
                        </b-form-group>
                        <b-btn variant="success"
                               :disabled="loading.save"
                                type="submit">
                            <font-awesome-icon icon="save" class="mr-1" />
                            <span>Save</span>
                            <b-spinner
                                v-if="loading.save"
                                small
                                class="ml-2" />
                        </b-btn>
                    </b-form>
                </div>
                <div class="col-md-6">

                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import TabsComponent from './Tabs.vue';

    import { mapState } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        props: ['user_id', 'mail_token'],
        data: function() {
            return {
                form: {
                    id: '',
                    email: '',
                    name: '',
                    password: '',
                },
                email_changed: false,
                loading: {
                    save: false,
                },
                verify_mail_success: false,
                error: '',
                error_message: '',
            }
        },
        computed: mapState({
            success: state => state.success,
            exceptions: state => state.exceptions
        }),
        created() {
            if (this.user_id && this.mail_token) {
                axios.post('/users/activate/' + this.user_id + '/' + this.mail_token)
                    .then(res => {
                        this.verify_mail_success = true;
                    })
                    .catch((error) => {
                        this.error = true;
                        this.error_message = error.response.data.message;
                    })
            }

            this.$store.dispatch('fetchAccount')
                .then(() => {
                    this.form.id = this.$store.getters.getAccount.id;
                    this.form.email = this.$store.getters.getAccount.email;
                    this.form.name = this.$store.getters.getAccount.name;
                });
        },
        methods: {
            onSubmit: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading.save = true;
                        this.$store.commit('CLEAR_EXCEPTIONS');
                        this.$store.commit('CLEAR_SUCCESS');
                        this.$store.dispatch('editAccount', this.form).then(res => {
                            if(res.data.data.email_changed) {
                                this.email_changed = true;
                            }
                        }).finally(() => {
                            this.loading.save = false;
                        });
                    }
                });
            },
        },
        beforeDestroy() {
            this.$store.commit('CLEAR_EXCEPTIONS');
            this.$store.commit('CLEAR_SUCCESS');
        },
        components: {
            TabsComponent,
        }
    }
</script>